<template>
    <div>
        <h3>Organise Files</h3>
        <p class="margin_bottom">Drag and drop files into the correct categories</p>


        <div class="md-layout md-gutter">

            <div class="md-layout-item md-size-25 md-medium-size-50 md-small-size-50">
                <div class="md-layout">

                    <div class="md-layout-item md-size-100">
                        <h3>Files</h3>
                        <p>Uploaded building files, drag to relevant category</p>
                        <draggable :list="files.unassigned" class="list-group source-list"
                                   :sort="false" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files" v-bind:move="onMoveHandler">
                            <file-item v-for="file in files.unassigned"
                                       :key="file.id" :file="file"
                                       class="list-group-item md-elevation-10"></file-item>
                        </draggable>

                    </div>

                    <div class="md-layout-item md-size-100">
                        <h3>To Delete</h3>
                        <p>Drag files here to delete them</p>
                        <draggable :list="filesToDelete" class="list-group source-list"
                                   :sort="false" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files" v-bind:move="onMoveHandler">
                            <file-item v-for="file in filesToDelete"
                                       :key="file.id" :file="file"
                                       class="list-group-item md-elevation-10"></file-item>
                        </draggable>

                    </div>

                </div>
            </div>




            <div class="md-layout-item md-size-25 md-medium-size-50 md-small-size-50">
                <div class="md-layout">

                    <div class="md-layout-item md-size-100">
                        <h3>Website Images/Videos</h3>
                        <p>Order according to priority/quality (optional)</p>
                        <draggable :list="files.websiteImagesAndVideos"
                                   class="list-group" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files" v-bind:move="onMoveHandler">
                            <transition-group type="transition" name="flip-list" tag="div">
                                <file-item v-for="file in files.websiteImagesAndVideos"
                                           :key="file.id" :file="file"
                                           class="list-group-item md-elevation-5"></file-item>
                            </transition-group>
                        </draggable>
                    </div>



                    <div class="md-layout-item md-size-100">
                        <h3>Tenant Logos</h3>
                        <p>Assigned to each tenant later (recommended)</p>
                        <draggable :list="files.tenantLogos"
                                   :sort="false" class="list-group" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files" v-bind:move="onMoveHandler">
                            <file-item v-for="file in files.tenantLogos"
                                       :key="file.id" :file="file"
                                       class="list-group-item md-elevation-5"></file-item>
                        </draggable>
                    </div>

                </div>
            </div>

            <div class="md-layout-item md-size-25 md-medium-size-50 md-small-size-50">
                <div class="md-layout">

                    <div class="md-layout-item md-size-100">
                        <h3>Floor Plans</h3>
                        <p>For website (recommended)</p>
                        <draggable :list="files.floorPlans"
                                   :sort="false" class="list-group" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files" v-bind:move="onMoveHandler">
                            <file-item v-for="file in files.floorPlans"
                                       :key="file.id" :file="file"
                                       class="list-group-item md-elevation-5"></file-item>
                        </draggable>
                    </div>

                    <div class="md-layout-item md-size-100">
                        <h3>Site Handbook</h3>
                        <p>Will be downloadable for tenants on website</p>
                        <draggable :list="files.siteHandbooks"
                                   :sort="false" class="list-group" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files" v-bind:move="onMoveHandler">
                            <file-item v-for="file in files.siteHandbooks"
                                       :key="file.id" :file="file"
                                       class="list-group-item md-elevation-5"></file-item>
                        </draggable>
                    </div>

                </div>
            </div>


            <div class="md-layout-item md-size-25 md-medium-size-50 md-small-size-50">
                <div class="md-layout">

                    <div class="md-layout-item md-size-100">
                        <h3>Budget Pack</h3>
                        <p>Service charge budget pack</p>
                        <draggable :list="files.budgets"
                                   :sort="false" class="list-group" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files" v-bind:move="onMoveHandler">
                            <file-item v-for="file in files.budgets"
                                       :key="file.id" :file="file"
                                       class="list-group-item md-elevation-5"></file-item>
                        </draggable>
                    </div>

                    <div class="md-layout-item md-size-100">
                        <h3>Reconciliation Pack</h3>
                        <p>Service charge reconciliation pack</p>
                        <draggable :list="files.reconciliationPacks"
                                   :sort="false" class="list-group" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files" v-bind:move="onMoveHandler">
                            <file-item v-for="file in files.reconciliationPacks"
                                       :key="file.id" :file="file"
                                       class="list-group-item md-elevation-5"></file-item>
                        </draggable>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import FileItem from "./FileItem.vue";
    import NotyTypes from "@/ts/NotyTypes";
    import { FileTypes } from "@/ts/buildingSpec";
    import RateLimit from "@/ts/RateLimit";

    var limit_file_move_msgs = new RateLimit(100);

    export default {
        name: 'BuildingFilesInfo',
        components: {
            draggable,
            FileItem
        },
        props: {
            files: null,
        },
        data() {
            return {
                filesToDelete: []
            }
        },
        methods: {
            onMoveHandler(evt) {

                var allowMove = true;
                var categoryName = "that category";
                var listTarget = evt.relatedContext.list;

                if (listTarget == this.files.tenantLogos) {
                    categoryName = "Tenant Logos";
                    allowMove = this.fileIsImage(evt.draggedContext.element);
                }
                else if (listTarget == this.files.websiteImagesAndVideos) {
                    categoryName = "Website Images/Videos";
                    allowMove = this.fileIsImageOrVid(evt.draggedContext.element);
                }

                //TODO: would like to "delay" the warning messages, as dragging OVER a list (to get to another) throws up the messages, which is annoying for user
                //console.log(`onMoveHandler ${evt.draggedContext.element.id} -> ${categoryName}`);

                if (!allowMove) {
                    if (limit_file_move_msgs.count("file_moves") < 1) {
                        limit_file_move_msgs.tick("file_moves");
                        this.$notify({
                            timeout: 2500,
                            message: `Not an appropriate file type for ${categoryName}`,
                            icon: "add_alert",
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: NotyTypes[NotyTypes.danger]
                        });
                    }
                }
                return allowMove;
            },
            fileIsImage(fileItem) {
                return fileItem.type == FileTypes.img;
            },
            fileIsImageOrVid(fileItem) {
                return this.fileIsImage(fileItem) || fileItem.type == FileTypes.vid;
            }
        }
    }
</script>

<style lang="scss">
</style>
